module.exports = __webpack_public_path__ + "static/media/about21.9999df82.webp";